export default __webpack_public_path__ + "assets/pdf/online.ca8c4dea.pdf";